'use client';
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';

export const LanguageSelector = () => {
  const locale = useLocale();
  const router = useRouter();

  const handleLanguageChange = (newLocale: string) => {
    document.cookie = `NEXT_LOCALE=${newLocale};path=/`;
    router.refresh();
  };
  return (
    <Select value={locale} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-fit">
        <SelectValue placeholder="Change language" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="fr">🇫🇷</SelectItem>
        <SelectItem value="en">🇺🇸</SelectItem>
        <SelectItem value="es">🇪🇸</SelectItem>
        <SelectItem value="de">🇩🇪</SelectItem>
        <SelectItem value="pt">🇵🇹</SelectItem>
        <SelectItem value="nl">🇳🇱</SelectItem>
        <SelectItem value="it">🇮🇹</SelectItem>
      </SelectContent>
    </Select>
  );
};
